import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import SeasonScheduledMatchModal from './SeasonScheduledMatchModal';
import * as myConstClass from '../../shared/constants/constants';

const ADMIN_LVL_MASTER = 0;				// same as Users.js
const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_SCORESHEETS = 10;

// not used
const cstTableHeaders = ['', 'Date', 'Sous-saison', 'Programme', 'Location', 'Map', 'Équipe A', 'Équipe B', 'Format', 'Statut', ''];

const cstDefaultSortOrder = ['asc', 'asc', 'asc', 'asc', 'asc', 'asc', 'asc', 'asc', 'asc'];
const cstDefaultSortFieldIdx = 1;

const cstGoogleMapColIdx = 4;
const cstSmIdColIdx = 9;

const TABLE_NBCOL = 9;

class SeasonSchedule extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			scheduleData: [],

      sortParams: {
				sortFieldIdx: cstDefaultSortFieldIdx,
				sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
				sortClass: []
			},

			modalScheduledMatch: {
				_id: '0',
				date: '',
				week: 1,
				seasonId: '0',
				locationId: '0',
				subSeasonId: '0',
				team1Id: '0',
				team2Id: '0',
				status: "",
				scoresheetFormatId: '0'
			},

			showSeasonScheduledMatchModal: false,
			loading: true,
		};

    this.handleSortTable = this.handleSortTable.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);
		this.createTableRow = this.createTableRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
    this.reloadData = this.reloadData.bind(this);
	}

	componentDidMount() {
		// console.log('SeasonSchedule: componentDidMount');
		if (this.props.season._id != undefined) {
			this.loadData(true);
		}
	}

  componentDidUpdate(prevProps) {
  	//console.log('SeasonSchedule: componentDidUpdate')
  	//console.log(this.props)
  	if (!this.props.bEnableSheduledPrograms) {
  		const path = './home';
			this.props.history.push(path);
		} else if (this.props.season._id !== prevProps.season._id) {
			this.loadData(true);
	  }
  }

	loadData(resetSorting) {
		var _this = this;
		Axios.get('/api/scheduledMatchs/seasonId/' + _this.props.season._id).then(function(response) {

			var scheduledMatchs = response.data;
			console.log('scheduledMatchs');
			console.log(scheduledMatchs);

			// build data
			_this.buildScheduledMatchsTable(scheduledMatchs, resetSorting);
		});	

	}

	buildScheduledMatchsTable(scheduledMatchs, resetSorting) {
		var scheduleData = [];
		scheduledMatchs.forEach((sm, smIdx) => {

			var scheduledMatchsRow = [];
			scheduledMatchsRow.push(moment(sm.date).local().format("YYYY-MM-DD"));
			scheduledMatchsRow.push(sm.subSeasonName);
			scheduledMatchsRow.push(sm.week);
			scheduledMatchsRow.push(sm.locationName);
			scheduledMatchsRow.push(sm.locationGooglemap);
			scheduledMatchsRow.push(sm.team1Name);
			scheduledMatchsRow.push(sm.team2Name);
			scheduledMatchsRow.push(sm.scoresheetFormatId);
			scheduledMatchsRow.push(sm.status);

			// _id
			scheduledMatchsRow.push(sm._id);
			scheduledMatchsRow.push(sm.seasonId);
			scheduledMatchsRow.push(sm.subSeasonId);
			scheduledMatchsRow.push(sm.locationId);
			scheduledMatchsRow.push(sm.team1Id);
			scheduledMatchsRow.push(sm.team2Id);

			scheduleData.push(scheduledMatchsRow);
		});

		var sortParams = this.state.sortParams;

		if (resetSorting)	{
			sortParams = {
				sortFieldIdx: cstDefaultSortFieldIdx,
				sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
				sortClass: []
			};
		};

		this.sortscheduleData(scheduleData, sortParams);
	}

	sortscheduleData(scheduleData, sortParams) {
	
		var _this = this;
		if (scheduleData.length !== 0) {

			var sortSign = 1;
			if (sortParams.sortOrder === 'desc') { 
				sortSign = -1; 
			}

			scheduleData.sort(function(a, b) {

				var valueA = 0;
				var valueB = 0;
				var compVal = 0;
				var fact1 = 0;
				var defFact = 0;

				// Criteria #1
				valueA = a[sortParams.sortFieldIdx];
				valueB = b[sortParams.sortFieldIdx];

				switch (typeof valueA) {
			    case "date":
						compVal = new Date(valueA) - new Date(valueB);
						break;
			    case "string":
			    	// test if string is numeric
			    	if (_this.isNumeric(valueA) && _this.isNumeric(valueB)) {
							compVal = parseInt(valueA, 10) - parseInt(valueB, 10);
			    	} else {
							compVal = valueA.localeCompare(valueB);
						}
						break;
			    case "number":
						compVal = valueA - valueB;
						break;
			    default:
						compVal = 0;
						break;
				}

				fact1 = (sortSign * compVal);
				defFact = a[0].localeCompare(b[0]);

				// Results
				if (fact1 !== 0) {
					return fact1;
				} else {
					return defFact;
				}
			});
		}

		this.setState({
			scheduleData: scheduleData,
			sortParams: sortParams,
			loading: false
		});
	}

	reloadData() {
		this.loadData(false);
	}

	render() {
		//console.log('SeasonSchedule: RENDER');
		//console.log(this.props.adminAccess.adminValidatedAccessLevel);
		//console.log(this.state.scheduleData)

		console.warn("ADD SCORESHEET FORMAT IN MATCH CREATION")

		// ADMIN LEVEL REQUESTED:  00-MASTER
		if (this.props.adminAccess.adminValidatedAccessLevel <= ADMIN_LVL_MASTER) {
			return (
				<div>

				<div className="row">
        <div className="col-12">
        	<h5>MATCHS CÉDULÉS</h5>
				</div>
				</div>

				{(this.state.loading) ?
					this.displaySpinner() : 
					this.displayData()
				}

				<br/><br/><br/>

				{/* Modal */}
				<SeasonScheduledMatchModal 
					className = {this.props.className}
					showModal = {this.state.showSeasonScheduledMatchModal}
					modalScheduledMatch = {this.state.modalScheduledMatch}
					season = {this.props.season}
					handleModalCancel = {this.handleModalCancel}
					reloadData = {this.reloadData}
				/>

				</div>
			);

		} else {
			return (
				<div className="col-md-9">   {/*padding-left already set in parent*/} 
					<p>Vous n'avez pas accès à cette section</p>
				</div>
			);
		}
	}

	displayData() {
		var sortClass = this.state.sortParams.sortClass;

		return (
			<div>

			<div className="row">
      <div className="col-12">
      	<p></p>
			</div>
			</div>

			<div className="row">
			<div className="col-12">
			<button className="btn btn-sm btn-primary btn-margin-topbottom-10 btn-extra-padding" 
				onClick={this.handleAddEditScheduledMatchClick.bind(this, "NEW SM")}>
				Nouveau match
			</button>
			</div>
			</div>

			<div className="table-responsive">
			<table className="table table-hover table-sm">
			<thead>
				<tr>
					<th></th>
					<th id='hdr.0' className={"statelo-sorting " + sortClass[0]} onClick={this.handleSortTable} > Date </th>
					<th id='hdr.1' className={"statelo-sorting " + sortClass[1]} onClick={this.handleSortTable} > Sous-saison	</th>
					<th id='hdr.2' className={"statelo-sorting " + sortClass[2]} onClick={this.handleSortTable} > Prog.	</th>
					<th id='hdr.3' className={"statelo-sorting " + sortClass[3]} onClick={this.handleSortTable} > Lieu </th>
					<th id='hdr.4' > Map </th>
					<th id='hdr.5' className={"statelo-sorting " + sortClass[5]} onClick={this.handleSortTable} > Équipe A </th>
					<th id='hdr.6' className={"statelo-sorting " + sortClass[6]} onClick={this.handleSortTable} > Équipe B </th>
					<th id='hdr.7' className={"statelo-sorting " + sortClass[7]} onClick={this.handleSortTable} > Format </th>
					<th id='hdr.8' className={"statelo-sorting " + sortClass[8]} onClick={this.handleSortTable} > Statut </th>
					<th></th>
				</tr>
			</thead>

			{this.displayTable()}
			</table>

			</div>
			</div>
		);
	}

	displayTable() {
		if (this.state.scheduleData.length === 0) {
			return (
				<tbody>
					<tr><td colSpan="99">Aucun match</td></tr>
				</tbody>
			)
		} else {
			return (
				<tbody>
					{this.state.scheduleData.map(this.createTableRow)}
				</tbody>
			)
		}
	}

  createTableRow(sm, smIdx) {
  	var trClass = "stateloListItemPointer ";
    return (
      <tr key={'sm.' + smIdx} onDoubleClick={this.handleAddEditScheduledMatchClick.bind(this, sm)} className={trClass}>
				<td><input name={'edit.' + smIdx} type="button" onClick={this.handleAddEditScheduledMatchClick.bind(this, sm)} value="Éditer"/></td>
				{sm.map(this.createDataCell.bind(this, smIdx))}
				<td><input name={'del.' + smIdx} type="button" onClick={this.handleDeleteScheduledMatchClick.bind(this, sm)} value="Supprimer"/></td>
      </tr>
    );
  }

	createDataCell(smIdx, dataCell, dataCellIdx) {
		// Hide schedule match _id
		if (dataCellIdx >= cstSmIdColIdx) {
			return;
		}

		if (dataCellIdx === cstGoogleMapColIdx) {
			return (
				<td key={"tdcell." + dataCellIdx}> <a href={dataCell} target="blank"><i className="fa fa-map-o"></i></a> </td>
			);
		} else {
			return (
				<td key={"tdcell." + dataCellIdx}> {dataCell} </td>
			);
		}
	}

	handleAddEditScheduledMatchClick(smItem) {
	 	//console.log('handleAddEditScheduledMatchClick');
	 	//console.log(smItem)

		// new scheduled match ?
		var modalScheduledMatch = {};
		if (smItem === "NEW SM") {

			// add scheduled match
			modalScheduledMatch = {
				_id: '0',
				date: '',
				week: 1,
				seasonId: this.props.season._id,
				locationId: '0',
				subSeasonId: '0',
				team1Id: '0',
				team2Id: '0',
				scoresheetFormatId: '0',
				status: ""
			};
			this.setState({
				modalScheduledMatch: modalScheduledMatch,
				showSeasonScheduledMatchModal: true
			});

		} else {
			// edit scheduled match
			modalScheduledMatch = JSON.parse(JSON.stringify(smItem));


			console.log('smItem')
			console.log(smItem)
			
			modalScheduledMatch = {
				_id: smItem[cstSmIdColIdx + 0],
				date: smItem[0],
				week: smItem[2],
				status: smItem[8],
				seasonId: smItem[cstSmIdColIdx + 1],
				subSeasonId: smItem[cstSmIdColIdx + 2],
				locationId: smItem[cstSmIdColIdx + 3],
				team1Id: smItem[cstSmIdColIdx + 4],
				team2Id: smItem[cstSmIdColIdx + 5],
			};

			this.setState({
				modalScheduledMatch: modalScheduledMatch,
				showSeasonScheduledMatchModal: true
			});
		}
	}

	handleDeleteScheduledMatchClick(smItem) {
		var _this = this;
		var confirmAns = window.confirm("Voulez-vous vraiment supprimer le match suivant: \n" + 
			"seasonId: " + smItem[0] + "\n" + "seasonId: " + smItem[0] );
	
		if (confirmAns) {
			// Save to DB
			Axios.delete('/api/scheduledMatchs/' + smItem[cstSmIdColIdx])
			.then(function(response) {
			 	_this.reloadData();
			})
			.catch(function(error) {
				console.log(error);
			});     
		}

	}

	handleSortTable(e) {
		var colIdx = parseInt(e.target.id.split(".")[1], 10);
		var sortOrder = this.state.sortParams.sortOrder;
		var sortFieldIdx = this.state.sortParams.sortFieldIdx;

		// Toggle sort order
		if (sortFieldIdx === colIdx) {
			if (sortOrder === 'desc') {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[colIdx];
		}

		var sortClass = [];
		for(var i = 0; i < (TABLE_NBCOL - 1); i++) {
			sortClass[i] = '';
		}
		sortClass[colIdx] = "statelo-sorting_" + sortOrder;

		var sortParams = {
			sortFieldIdx: colIdx,
			sortOrder: sortOrder,
			sortClass: sortClass
		};

		this.sortscheduleData(this.state.scheduleData, sortParams);
	}

	handleModalCancel() {
		this.setState({ 
			showSeasonScheduledMatchModal: false
		});
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	// isNumeric function in javascript
	isNumeric(n) {
  	return !isNaN(parseFloat(n)) && isFinite(n);
	}

}

export default SeasonSchedule;
